import { Navigate } from 'react-router';

import { FOOTBALL_PREMIER_LEAGUE } from '@sorare/core/src/constants/__generated__/routes';

const PLPage = () => {
  return <Navigate to={FOOTBALL_PREMIER_LEAGUE} />;
};
export default PLPage;
